import http, { url } from '../../http'

const API_URL = "self_report_cm"

class unsafeReportAPI {

  async save(unsafe) {
    const response = await http(`${API_URL}/save`, 'POST', unsafe)
    return response
  }

  async save2(healt) {
    const response = await http(`${API_URL}/healt/save`, 'POST', healt)
    return response
  }

  async save3(evidence) {
    const response = await http(`${API_URL}/evidence/save`, 'POST', evidence)
    return response
  }
 
  async getAllunsafe(id) {
    const response = await http(`self_report_cm/index/${id}`, 'POST')
    return response
  } 

  async getAllhealt(id) {
    const response = await http(`${API_URL}/healt/index/${id}`, 'POST')
    return response
  } 

  async getAllEvidence(id) {
    const response = await http(`${API_URL}/evidence/index/${id}`, 'POST')
    return response
  } 

  async getEvidence(id) {
    const response = await http(`${API_URL}/evidence/${id}`)
    return response
  }

  async getHealt(id) {
    const response = await http(`${API_URL}/healt/${id}`)
    return response
  }

  async getUnsafe(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateEvidence(id, evidence) {
    const response = await http(`${API_URL}/evidence/update/${id}`, 'PUT', evidence)
    return response
  }

  async updateHealt(id, healt) {
    const response = await http(`${API_URL}/healt/update/${id}`, 'PUT', healt)
    return response
  }

  async updateUnsafe(id, unsafe) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', unsafe)
    return response
  }
 
  async deleteIdentification(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }
 
}

export default new unsafeReportAPI()